import clsx from 'clsx'
import { Avatar } from './avatar'
import { Fragment } from 'react/jsx-runtime'
import sumoLogo from '../images/sumo_logo.png';
export function LogoHeading({ className, level = 1, ...props }) {
  let Element = `h${level}`

  return (
    <Fragment>
        <span className="flex min-w-0 items-center gap-1 mb-2">
        <Avatar src={sumoLogo} className="size-10" square alt="" />
        <Element
        {...props}
        className={clsx(className, 'text-2xl/8 font-semibold text-zinc-950 sm:text-2xl/8 dark:text-white px-2 mb-2 cursor-pointer')}
        />
        </span>
        </Fragment>
  )
}
export function HomepageLogo({ className, level = 1, ...props }) {
  let Element = `h${level}`

  return (
    <Fragment>
        <span className="flex min-w-0 items-center gap-1">
        <Avatar src={sumoLogo} className="size-10" square alt="" />
        <Element
        {...props}
        className={clsx(className, 'text-2xl/8 font-semibold text-zinc-950 sm:text-2xl/8 cursor-pointer')}
        />
        </span>
        </Fragment>
  )
}